module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">Are you sure to delete this basket?</h3>\n</div>\n\n<div class=\"modal-body\" id=\"modal-body\">\n    <span>\n        Delete BASKET for <b>{{$ctrl.basket.defaultPickupOption.name}}</b>\n    </span>\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/membership/membershipBasketDelete.html
// module id = 231
// module chunks = 0